const parseErrorMessage = (e) => {
    const t = typeof e.message;
    if (t === 'function') return e.message();
    return e.message;
};

export default parseErrorMessage;